import '../styles/PageGlobal.css';
import './FournisseurNewPage.css';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FournisseurService } from '../services/FournisseurService.js';

export default function FournisseurNewPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({ societe1: '', societe2: '', adresse1: '', codePostal: '', ville: '', pays: 'France', telephone: '', siret: '' });
 

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
 

  const handleSave = async () => {
    const service = new FournisseurService();
    setLoading(true);
    try {
      const payload = {
        ...form
      };
      await service.createFournisseur(payload);
      alert("Créé avec succès !");
      navigate('/fournisseur_list');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="containerMain fournisseur-new-container">
      <h1 className="fournisseur-new-title">Créer un Fournisseur</h1>
      {error && <div className="fournisseur-error">{error}</div>}
      
      <div className="fournisseur-new-form">
        <div className="fournisseur-new-row"><label>Société 1 *</label><input name="societe1" value={form.societe1} onChange={handleChange} required /></div>
        <div className="fournisseur-new-row"><label>Société 2</label><input name="societe2" value={form.societe2} onChange={handleChange} /></div>
        <div className="fournisseur-new-row"><label>Adresse 1 *</label><input name="adresse1" value={form.adresse1} onChange={handleChange} required /></div>
        <div className="fournisseur-new-row"><label>Code Postal *</label><input name="codePostal" value={form.codePostal} onChange={handleChange} required /></div>
        <div className="fournisseur-new-row"><label>Ville *</label><input name="ville" value={form.ville} onChange={handleChange} required /></div>
        <div className="fournisseur-new-row"><label>Téléphone *</label><input name="telephone" value={form.telephone} onChange={handleChange} required /></div>
        <div className="fournisseur-new-row"><label>SIRET</label><input name="siret" value={form.siret} onChange={handleChange} maxLength={14} /></div>
      </div>

      
      <div className="fournisseur-new-footer">
        <button className="fournisseur-btn fournisseur-btn-blue" onClick={handleSave} disabled={loading}>{loading ? '...' : 'Enregistrer'}</button>
        <button className="fournisseur-btn fournisseur-btn-grey" onClick={() => navigate("/fournisseur_list")}>Annuler</button>
      </div>
    </div>
  );
}